export default {
  I00DEBGAZ_HEADER: 'Calculez le débit gaz de votre installation',
  I00DEBGAZ_TYPE_GAZ: 'Choississez un type de gaz',
  I00DEBGAZ_in_pci: 'PCI',
  I00DEBGAZ_in_pressionGaz: 'Pression Gaz',
  I00DEBGAZ_in_puissanceNominale: 'Puissance nominale chaudière',
  I00DEBGAZ_in_temperatureGaz: 'Température Gaz',
  I00DEBGAZ_in_pressionAtmospherique: 'Pression atmosphérique',
  I00DEBGAZ_res_debitNormaux: 'Débit normaux',
  I00DEBGAZ_res_debitGazReel: 'Débit gaz réel',
  I00DEBGAZ_res_debitTopGaz36: 'Débit top gaz 36s',
  I00DEBGAZ_mail_TypeGaz: 'Type de gaz'
}
